import { Button, Card, Col, Form, Image, Input, Row } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {  getMyPermissions, requestAdminLogin, requestLogin, setAdminToken, setUserProfile } from "../../core/store/reducers/auth.slice";
import LoginLayout from "../../shared/layouts/login.layout";
import { ROUTE_FORGET_PASSWORD } from "../../shared/routes/auth.routes";
import { BiLogInCircle } from "react-icons/bi";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { RootState } from "../../shared/types/common";
import { loginRequest } from "../../msalConfig";

const LoginPage: React.FC = () => {
  return <LoginLayout loginForm={<LoginForm />}></LoginLayout>;
};
export default LoginPage;

const LoginForm: React.FC = () => {
  const { accessToken } = useSelector(
    (state: RootState) => state.auth
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Handle redirect response after login
    if (accounts?.length > 0 && accessToken && isAuthenticated ) return;
    instance
      .handleRedirectPromise()
      .then((response) => {
        if (response) {
          setLoading(true);
          // console.log(response);
          dispatch(requestAdminLogin({ token: response?.idToken }))
            .then(async (res: any) => {
              await new Promise((resolve) => setTimeout(resolve, 1000));
              if (res?.payload?.data?.data?.access_token) {
                await dispatch(
                  setAdminToken(res?.payload?.data?.data?.access_token)
                  
                );
                await dispatch(
                  
                  setUserProfile(res?.payload?.data?.data?.user)
                );
                await dispatch(getMyPermissions())
                // const response = await dispatch(getAdminProfile()).unwrap();
                // const roleId = response?.data?.data?.role_id;

              } else {
                sessionStorage.clear();
                // notification.error({ message: t("LOGIN.LOGIN_ERROR") })
              }
              setLoading(false);
            })
            .catch((error: any) => {
              console.log(error);
              setLoading(false);
            });
        }
      })
      .catch((error) => console.log(error));
  }, [instance, accounts]);

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch((error) => {
      console.log(error);
    });
  };

  const onValuesChange = (e: any) => {};
  const onFinish = async (values: any) => {
    setLoading(true);
    const data = {
      userName: values?.username,
      password: values?.password,
    };
    await dispatch(requestLogin(data));
    // await dispatch(mockLogin());
    setLoading(false);
  };
  return (
    <>
      <Row justify="center" align="middle" className="h-100 login-bg" style={{backgroundImage: 'url(assets/images/login-bg.png)'}}>
        <Col
          xs={{ span: 22 }}
          md={{ span: 11 }}
          lg={{ span: 10 }}
          xl={{ span: 7 }}
        >
          <Card className="login-card shadow">
            <p className="text-center">
              {/* <img src={'assets/images/logo-placeholder.png'} className="logo" /> */}
              <h1 className="sidebar-logo" style={{color: 'gray', fontWeight: 'bold', fontSize: '25px'}}>
                <img src={'/assets/images/robotico-logo.svg'} className="logo" style={{maxWidth : '70%', width: '200px'}} />
              </h1>
            </p>
            <Form
              name="normal_login"
              className="login-form"
              layout="vertical"
              onFinish={handleLogin}
              initialValues={{}}
              onValuesChange={onValuesChange}
            >
              {/* <Form.Item
                name="username"
                label={"User Name"}
                rules={[
                  {
                    required: true,
                    message: "User Name is required!",
                  },
                  // {
                  //   type: "email",
                  //   message: "Email ID is invalid!",
                  // },
                ]}
              >
                <Input size="large" placeholder={"User Name"} />
              </Form.Item>
              <Form.Item
                name="password"
                label={"PASSWORD"}
                rules={[
                  {
                    required: true,
                    message: "Password is required!",
                  },
                ]}
              >
                <Input.Password
                  size="large"
                  placeholder={"Password"}
                />
              </Form.Item> */}
              
              <Row align="middle">
                {/* <Col span={16}>
                <Button
                  className="mb-4"
                  type="link"
                  onClick={() => navigate(ROUTE_FORGET_PASSWORD)}
                >
                  FORGOT PASSWORD
                </Button>
                </Col> */}
                <Col span={24} className="mt-10">
                <Form.Item>
                <Button
                  loading={loading || isAuthenticated || accounts?.length > 0}
                  type="primary"
                  block
                  htmlType="submit"
                  size="large"
                >
                  SIGN IN
                </Button>
              </Form.Item>
                </Col>
              </Row>
            </Form>
            <div className="text-center mt-5">
              &copy; {moment().format("YYYY")} Robotico Digital LLP
            </div>
          </Card>
        </Col>
      </Row>
    </>
  );
};

